import React, { useEffect, useRef, useState } from "react";
import { Button, Chip, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Alert from "@material-ui/lab/Alert";
import { useTranslation } from "react-i18next";
import { taskRequest } from "./api";
import { userName } from "./TaskDialog";

export default function BoardMembersDialog({ board, onClose, onChanged }) {
  const { t } = useTranslation();
  const [members, setMembers] = useState([]);
  const [users, setUsers] = useState([]);
  const [selected, setSelected] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const mutation = useRef(false);

  useEffect(() => {
    let active = true;
    taskRequest("get_task_board_members", { boardId: board.id }).then((result) => {
      if (active) { setMembers(result.members); setUsers(result.users); }
    }).catch((err) => { if (active) setError(err.message); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [board.id]);

  const addMembers = async () => {
    if (mutation.current || !selected.length) return;
    mutation.current = true;
    setSaving(true);
    setError("");
    try {
      await taskRequest("add_task_board_members", { boardId: board.id, userIds: selected.map((user) => user.id) });
      setMembers((previous) => [...previous, ...selected]);
      setSelected([]);
      if (onChanged) onChanged();
    } catch (err) { setError(err.message); }
    finally { setSaving(false); mutation.current = false; }
  };

  return <Dialog open fullWidth maxWidth="sm" onClose={() => { if (!saving) onClose(); }} aria-labelledby="board-members-title">
    <DialogTitle id="board-members-title">{t("tasks.members")} — {board.name}</DialogTitle>
    <DialogContent>
      {error && <Alert severity="error" role="alert">{error}</Alert>}
      {loading ? <CircularProgress /> : <>
        <Typography paragraph color="textSecondary">{t("tasks.membersHelp")}</Typography>
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 16 }}>
          {members.map((member) => <Chip key={member.id} label={userName(member)} />)}
        </div>
        <Autocomplete id="board-new-members" multiple options={users.filter((user) => !members.some((member) => member.id === user.id))}
          getOptionLabel={userName} getOptionSelected={(a, b) => a.id === b.id} value={selected} disabled={saving}
          onChange={(event, value) => setSelected(value)}
          renderInput={(params) => <TextField {...params} variant="outlined" label={t("tasks.selectMembers")} />} />
      </>}
    </DialogContent>
    <DialogActions>
      {saving && <CircularProgress size={20} />}
      <Button disabled={saving} onClick={onClose}>{t("tasks.close")}</Button>
      <Button color="primary" disabled={loading || saving || !selected.length} onClick={addMembers}>{t("tasks.addMembers")}</Button>
    </DialogActions>
  </Dialog>;
}
